import React, { useEffect, useMemo } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionFaturacionSucursal} from '../../../../actions/action-creators'
import { isNullOrEmpty } from '../../../../utils/strings.utils'
import { facturacionFormSucursalHandleChange } from '../../../../actions/facturacion/facturacionSucursal.actions'
import { facturacionClearAll, facturacionSetCatalogoSerie } from '../../../../actions/facturacion/facturacionEmision.actions'
import { encontrarSerieActiva, encontrarSucursalConDocs } from '../../../../utils/invoice/sucursales_docs'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import { showMessageSucursalVacia } from '../../../../actions/userLogin.actions'
import { useHistory } from 'react-router-dom'

const DatosSucursal = () => {
  const history = useHistory();
  const {activeDoc} = useSelector((state: State) => state.documentos)
  const {sucursalesCargadas} = useSelector((state: State) => state.facturacion)
  const sucursales = useSelector((state: State) => state.facturacion.catalogoSucursal)
  const series = useSelector((state: State) => state.facturacion.catalogoSerie)
  const form = useSelector((state: State) => state.facturacion.formSucursal)
  const errors = useSelector((state: State) => state.facturacion.errorsFormSucursal)
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionFaturacionSucursal, dispatch)

  useEffect(() => {
    if (sucursales.length > 0) {
      try {
        const sucursalDefault = sucursales[0];
        const serieDefault = sucursalDefault?.Documento[0];
        
        if (sucursalDefault && serieDefault) {
          dispatch(facturacionSetCatalogoSerie(sucursalDefault.Documento));
          dispatch(facturacionFormSucursalHandleChange({
            'sucursal': sucursalDefault.idsucursal,
            'serie': serieDefault.idsucursaldocumento,
            'datosSerie': serieDefault,
          }));
        } else {
          dispatch(facturacionFormSucursalHandleChange({
            'sucursal': '',
            'serie': '',
          }));
        }
      } catch(e) {}
    } else {
      if (sucursalesCargadas) {
        dispatch(showMessageSucursalVacia('Factura'));
        history.push('/home');
        dispatch(facturacionClearAll());
      }
    }
  }, [sucursales]);

  return (
    <form
      className='form-content'
      data-wf-page-id='64b58c72be2b65200b1e6fa6'
      data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
      
      style={{marginBottom: '5%'}}
    >
      <div>
        <h3 className='card-title l'>Sucursal y Serie</h3>
      </div>
      <div className='form-separator'></div>
      <div className='w-layout-hflex h-inputs'>
        <div className='label-input'>
          <label htmlFor='sucursal' className='field-label m'>
            Sucursal
            <span style={{color: 'red'}}>*</span>
          </label>
          <SearchSelect 
            data={sucursales} 
            keyNameText='nombre' 
            keyNameValue='idsucursal' 
            name='sucursal' 
            value={form.sucursal} 
            placeholder='Sucursal' 
            disabled={true} 
            onChange={(value: any) => {acciones.facturacionFormSucursalHandleChangeInput({target: {value: value?.value, name: 'sucursal'}}); acciones.facturacionFormSucursalOnBlur({target: {value: value?.value, name: 'sucursal'}})}}
            />
          {errors.sucursal && <p className='alert s'>{errors.sucursal}</p>}
        </div>
        <div className='label-input'>
          <label htmlFor='serie' className='field-label m'>
            Serie
            <span style={{color: 'red'}}>*</span>
          </label>
          <SearchSelect 
            data={series.map((serie) => {return({...serie, serie_numero: `${serie?.serie}-${serie?.numeroactual}`})})} 
            keyNameText='serie_numero' 
            keyNameValue='idsucursaldocumento' 
            name='serie' 
            value={form.serie} 
            placeholder='Serie' 
            disabled={!sucursalesCargadas} 
            onChange={(value: any) => {acciones.facturacionFormSucursalHandleChangeInput({target: {value: value?.value, name: 'serie'}}); acciones.facturacionFormSucursalOnBlur({target: {value: value?.value, name: 'serie'}})}}
          />
          {errors.serie && <p className='alert s'>{errors.serie}</p>}
        </div>
      </div>
      <div className='separador'></div>
    </form>
  )
}

export default DatosSucursal
